import { IMiscPersistedState } from "@monorepo/types";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {} as IMiscPersistedState;

const miscPersistedSlice = createSlice({
  name: "miscPersisted",
  initialState,
  reducers: {
    closeMessageForMobile(state) {
      return { ...state, messageForMobileClosed: true };
    },
  },
});

export const { closeMessageForMobile } = miscPersistedSlice.actions;
export default miscPersistedSlice.reducer;
